
import { useTranslation } from 'react-i18next';
import Button from '../../../components/base/Button';

export default function CTASection() {
  const { t } = useTranslation();

  const handleContactClick = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section 
      className="py-20 relative overflow-hidden"
      style={{
        backgroundImage: `linear-gradient(rgba(59, 130, 246, 0.9), rgba(147, 51, 234, 0.9)), url('/resources/cta-bg-001.jpg')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center text-white relative z-10">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl md:text-5xl font-bold mb-6">
            {t('cta_title')}
          </h2>
          <p className="text-lg md:text-xl mb-2 text-blue-100">
            {t('cta_subtitle')}
          </p>
          <p className="text-xl md:text-2xl mb-12 text-blue-100 max-w-3xl mx-auto leading-relaxed">
            {t('cta_description')}
          </p>
          
          <div className="flex justify-center">
            <button onClick={handleContactClick}>
              <Button 
                size="lg"
                className="text-lg px-10 py-4 bg-white text-blue-600 hover:bg-gray-100"
              >
                <i className="ri-customer-service-line mr-2"></i>
                {t('nav_consult')}
              </Button>
            </button>
          </div>

          <div className="mt-16 grid md:grid-cols-3 gap-8 text-center">
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6">
              <i className="ri-phone-line text-3xl mb-4"></i>
              <h3 className="text-lg font-semibold mb-2">{t('cta_phone_title')}</h3>
              <p className="text-blue-100">{t('cta_phone_desc')}</p>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6">
              <i className="ri-mail-line text-3xl mb-4"></i>
              <h3 className="text-lg font-semibold mb-2">{t('cta_email_title')}</h3>
              <p className="text-blue-100">{t('cta_email_desc')}</p>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6">
              <i className="ri-wechat-line text-3xl mb-4"></i>
              <h3 className="text-lg font-semibold mb-2">{t('cta_wechat_title')}</h3>
              <p className="text-blue-100">{t('cta_wechat_desc')}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
